import { isRejectedWithValue } from "@reduxjs/toolkit";
import { setError } from "features/error/error";
import store from "store";

/**
 * Log a warning and show a toast!
 */
const existNotAcceptableWords = ['MongoId', 'GET', '/m/'];
function doesMessageIncludeUnacceptableWords(message) {
  if (Array.isArray(message)) {
    return existNotAcceptableWords.some((word) => message[0].toLowerCase().includes(word.toLowerCase()));
  } else {
    return existNotAcceptableWords.some((word) => message?.toLowerCase().includes(word.toLowerCase()));
  }
}
export const rtkQueryErrorLogger = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const showDefaultError =
      action.payload.status === 500 || doesMessageIncludeUnacceptableWords(action?.payload?.data?.message);
    if (action?.payload?.status === 400) {
      store.dispatch(
        setError({
          title: '',
          message: action?.payload?.data?.message || 'Oops! Something went wrong',
        })
      );
    }

    if (action?.payload?.status !== 404) {
      if (showDefaultError) {
        store.dispatch(
          setError({
            title: '',
            message: 'Oops! Something went wrong',
          })
        );
      } else {
        store.dispatch(
          setError({
            message: action?.payload?.data?.message || action?.payload?.message || 'Oops! Something went wrong',
            title: '',
          })
        );
      }
    }
  }
  return next(action);
};